/**
 * Configurations getters
 */
export default {
  defaultObject () {
    return {
      id: null,
      calculationConstant: 0.0,
      numberOfEvents: 0
    }
  }
}